/**
 * Neutraliza el chrome de la app anfitriona para que no se filtre al PDF.
 *
 * `packages/configs/styles.css` define, dentro de `@layer base`:
 *   body { @apply bg-background text-foreground min-h-screen }
 * Las reglas de acá van sin capa, así que ganan por precedencia de cascade
 * layers — no hace falta `!important`.
 *
 * `min-height: 100vh` en el body es lo más importante de resetear: le mete a
 * Chromium una página en blanco extra al paginar.
 *
 * Precedente del patrón en el repo: `shared-components/components/AuthLayout.tsx`
 * inyecta un `<style>` crudo para pintar el fondo de las pantallas de login.
 */
export const DocumentStyleReset = () => (
  <style
    dangerouslySetInnerHTML={{
      __html: `
        @page { size: A4; }

        html {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        body {
          min-height: 0;
          margin: 0;
          background: #fff;
        }
      `,
    }}
  />
)
